import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import Section from "../../components/section";
import React from "react";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Plus from "../../components/svg/plus";
import Label from "../../components/label";
import Trash from "../../components/svg/trash";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import ReactQuill from "react-quill";
import { FormikTextarea } from "../../components/textarea";

export default function AddUser() {
  return (
    <div className="p-3 bg-[#fffbf4] ">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    initialValues,
    handleUserImagesAdd,
    handleUserImagesDelete,
    userImagesArray,
    handleScaleAdd,
    handleScaleDelete,
    scaleToDelete,
    handleConfirmScaleDelete,
    handleCancelScaleDelete,
    scaleArrayRef,
    trainersArrayRef,
    handleTrainerAdd,
    handleTrainerDelete,
    toolsArrayRef,
    handleToolAdd,
    handleToolDelete,
    levelUpsArrayRef,
    handleLevelUpAdd,
    handleLevelUpDelete,
    handleSubmit,
    updateHomeQuery,
    handleAddStep,
    handleDeleteStep,
    stepsArrayRef,
    multiTitleArrayRef,
    handleMultiTitleAdd,
    handleMultiTitleDelete,
  } = usePageProvider();

  return (
    <Section>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">
              <Accordion.Item eventKey="30" className="w-[100%]  ml-[1rem] ">
                <Accordion.Header>SEO META</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black font-semibold text-[15px]" />
                      <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" className="w-[100%]  ml-[1rem] ">
                <Accordion.Header>Header</Accordion.Header>
                <Accordion.Body>
                  <Accordion>
                    <Accordion.Item eventKey="19">
                      <Accordion.Header>Banner Details</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                          <div className="flex flex-col">
                            <Label label="Primary Heading" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.primary_heading" rootClassName="w-full" />
                          </div>

                          <div className="flex flex-col">
                            <Label label="Secondery Heading" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.secondary_heading" rootClassName="w-full" />
                          </div>
                        </div>
                        <div className="flex flex-col mt-2">
                          <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                          <FormikTextarea name="header.description" rootClassName="w-full" />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Accordion className="mt-2">
                    <Accordion.Item eventKey="20">
                      <Accordion.Header>User Images And CTA Buttons</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 mt-6">
                          <div className="flex flex-col">
                            <Label label="CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.primary_cta.label" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="CTA Redirect link" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.primary_cta.redirect_link" rootClassName="w-full" />
                          </div>

                          <div className="flex flex-col">
                            <Label label="Secondery CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.secondary_cta.label" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="Secondery Redirect link" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.secondary_cta.redirect_link" rootClassName="w-full" />
                          </div>
                        </div>

                        <div className="flex justify-end mt-3">
                          <div className=" bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer ">
                            <Plus onClick={handleUserImagesAdd} className={" text-[white]"} />
                          </div>
                        </div>

                        <div className="mt-3 overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[40%] border font-normal border-gray-300 px-2 py-2 text-left">User Images</th>
                                <th className="w-[50%] border font-normal border-gray-300 px-2 py-2 text-left">Alt Tag</th>
                                <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <FieldArray
                                name="header.user_images"
                                render={(arrayHelper) => {
                                  userImagesArray.current = arrayHelper;
                                  return (
                                    <>
                                      {values?.header?.user_images?.map((item, index) => (
                                        <tr key={index}>
                                          <td className="w-[95%] border border-gray-300 px-4 py-2">
                                            <ImageUploader
                                              imgStyle={{ width: "8rem" }}
                                              title="image"
                                              imageUrl={values?.header?.user_images?.[index]?.image_url}
                                              onChange={(res) => {
                                                setFieldValue(`header.user_images.${index}.image_url`, res?.data?.file_url);
                                              }}
                                            />
                                          </td>
                                          <td className="border px-2 py-2">
                                            <FormikInput name={`header.user_images.${index}.alt_tag`} rootClassName="w-full" />
                                          </td>
                                          <td className="w-[5%] border border-gray-300 px-4 py-2">
                                            <div className="flex justify-center cursor-pointer" onClick={handleUserImagesDelete(index)}>
                                              <Trash />
                                            </div>
                                          </td>
                                        </tr>
                                      ))}
                                    </>
                                  );
                                }}
                              />
                            </tbody>
                          </table>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Accordion className="my-2">
                    <Accordion.Item eventKey="21">
                      <Accordion.Header>Banner Images</Accordion.Header>
                      <Accordion.Body>
                        <div className="flex flex-col">
                          <Label label="Alt Tag" className="mb-2 text-black text-[15px] font-semibold" />
                          <FormikInput name="header.banner_image.alt_tag" rootClassName="w-full" />
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 my-4 gap-3">
                          <div className="flex flex-col">
                            <Label label="Desktop Banner Image" className="mb-2 text-black text-[15px] font-semibold" />
                            <ImageUploader
                              className="w-full"
                              title="image"
                              name="header.banner_image.desktop"
                              imageUrl={values?.header?.banner_image?.desktop}
                              onChange={(res) => {
                                setFieldValue(`header.banner_image.desktop`, res?.data?.file_url);
                              }}
                            />
                          </div>
                          <div className="flex flex-col">
                            <Label label="Mobile Banner Image" className="mb-2 text-black text-[15px] font-semibold" />
                            <ImageUploader
                              className="w-full"
                              title="image"
                              name="header.banner_image.mobile"
                              imageUrl={values?.header?.banner_image?.mobile}
                              onChange={(res) => {
                                setFieldValue(`header.banner_image.mobile`, res?.data?.file_url);
                              }}
                            />
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Ready to Scale</Accordion.Header>
                <Accordion.Body>
                  <Accordion>
                    <Accordion.Item eventKey="26">
                      <Accordion.Header>Scales Details</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                          <div className="flex flex-col">
                            <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="section_scale.heading" rootClassName="w-full" />
                          </div>
                        </div>
                        <div className="flex flex-col mt-2">
                          <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                          <FormikTextarea name="section_scale.description" rootClassName="w-full" as="textarea" />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Accordion className="mt-2">
                    <Accordion.Item eventKey="22">
                      <Accordion.Header>Scales</Accordion.Header>
                      <Accordion.Body>
                        <div className="flex justify-end mb-1">
                          <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={handleScaleAdd}>
                            <Plus className="text-white" />
                          </div>
                        </div>

                        <div className="mt-2 overflow-x-auto">
                          <FieldArray
                            name="section_scale.scales"
                            render={(arrayHelpers) => {
                              scaleArrayRef.current = arrayHelpers;

                              return (
                                <div className="space-y-6">
                                  {values?.section_scale?.scales?.map((item, index) => (
                                    <table key={`row-${index}`} className="w-full table-fixed border-collapse border border-gray-300">
                                      <thead className="bg-gray-200">
                                        <tr>
                                          <th className="w-[20%] font-normal border px-2 py-2">Title</th>
                                          <th className="w-[20%] font-normal border px-2 py-2">Alt Tag</th>
                                          <th className="w-[20%] font-normal border px-2 py-2">Desktop Image</th>
                                          <th className="w-[20%] font-normal border px-2 py-2">Mobile Image</th>
                                          <th className="w-[5%] font-normal border px-2 py-2 text-center">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <React.Fragment>
                                          <tr>
                                            <td className="border px-2 py-2">
                                              <FormikInput name={`section_scale.scales.${index}.title`} rootClassName="w-full" />
                                            </td>
                                            <td className="border px-2 py-2">
                                              <FormikInput name={`section_scale.scales.${index}.alt_tag`} rootClassName="w-full" />
                                            </td>
                                            <td className="border px-2 py-2">
                                              <ImageUploader
                                                title="Desktop"
                                                imageUrl={item.image_url.desktop}
                                                onChange={(res) =>
                                                  setFieldValue(`section_scale.scales.${index}.image_url.desktop`, res?.data?.file_url)
                                                }
                                              />
                                            </td>
                                            <td className="border px-2 py-2">
                                              <ImageUploader
                                                title="Mobile"
                                                imageUrl={item.image_url.mobile}
                                                onChange={(res) =>
                                                  setFieldValue(`section_scale.scales.${index}.image_url.mobile`, res?.data?.file_url)
                                                }
                                              />
                                            </td>
                                            <td className="border px-2 py-2 text-center" rowSpan={2}>
                                              <div
                                                className="flex justify-center cursor-pointer h-full items-center"
                                                onClick={handleScaleDelete(index)}
                                              >
                                                <Trash />
                                              </div>
                                            </td>
                                          </tr>

                                          <tr>
                                            <td colSpan={4} className="border px-2 py-2">
                                              <label className="block text-gray-700 text-sm font-semibold mb-2">Description</label>
                                              <ReactQuill
                                                theme="snow"
                                                value={item.description}
                                                onChange={(e) => setFieldValue(`section_scale.scales.${index}.description`, e)}
                                              />
                                            </td>
                                          </tr>
                                        </React.Fragment>
                                      </tbody>
                                    </table>
                                  ))}
                                </div>
                              );
                            }}
                          />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Trainers Section</Accordion.Header>
                <Accordion.Body>
                  <Accordion>
                    <Accordion.Item eventKey="40">
                      <Accordion.Header>Trainers Details</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-3  gap-3">
                          <div className="flex flex-col">
                            <Label label="Title" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="section_trainers.title" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="CTA Lable" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="section_trainers.cta.label" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="section_trainers.cta.redirect_link" rootClassName="w-full" />
                          </div>
                        </div>

                        <div className="flex justify-end mt-3">
                          <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={handleMultiTitleAdd}>
                            <Plus className="text-white" />
                          </div>
                        </div>

                        <FieldArray name="section_trainers.multi_title">
                          {(arrayHelpers) => {
                            multiTitleArrayRef.current = arrayHelpers;

                            return (
                              <div className="mt-2 overflow-x-auto">
                                <table className="w-full table-fixed border-collapse border border-gray-300">
                                  <thead className="bg-gray-200">
                                    <tr>
                                      <th className="w-[90%] border font-normal border-gray-300 px-2 py-2 text-left">Multiple Title Keys</th>
                                      <th className="w-[10%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {values?.section_trainers?.multi_title?.map((item, index) => (
                                      <tr key={index}>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <FormikInput name={`section_trainers.multi_title.${index}.title`} rootClassName="w-full" />
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-center">
                                          <div className="flex justify-center cursor-pointer" onClick={handleMultiTitleDelete(index)}>
                                            <Trash />
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            );
                          }}
                        </FieldArray>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Accordion>
                    <Accordion.Item eventKey="52" className="mt-2">
                      <Accordion.Header>Count Section</Accordion.Header>
                      <Accordion.Body>
                        <div className="flex justify-end mt-3">
                          <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={handleTrainerAdd}>
                            <Plus className="text-white" />
                          </div>
                        </div>

                        <FieldArray name="section_trainers.trainers">
                          {(arrayHelpers) => {
                            trainersArrayRef.current = arrayHelpers;
                            return (
                              <div className="mt-2 overflow-x-auto">
                                <table className="w-full table-fixed border-collapse border border-gray-300">
                                  <thead className="bg-gray-200">
                                    <tr>
                                      <th className="w-[40%] border font-normal border-gray-300 px-2 py-2 text-left">Title</th>
                                      <th className="w-[40%] border font-normal border-gray-300 px-2 py-2 text-left">Count</th>
                                      <th className="w-[40%] border font-normal border-gray-300 px-2 py-2 text-left">Suffix</th>
                                      <th className="w-[10%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {values?.section_trainers?.trainers?.map((item, index) => (
                                      <tr key={index}>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <FormikInput name={`section_trainers.trainers.${index}.title`} rootClassName="w-full" />
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <FormikInput name={`section_trainers.trainers.${index}.count`} rootClassName="w-full" />
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <FormikInput name={`section_trainers.trainers.${index}.suffix`} rootClassName="w-full" />
                                        </td>

                                        <td className="border border-gray-300 px-4 py-2 text-center">
                                          <div className="flex justify-center cursor-pointer" onClick={handleTrainerDelete(index)}>
                                            <Trash />
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            );
                          }}
                        </FieldArray>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Turning your knowledge into income has never been this easy</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Primary Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="section_knowledge.primary_heading" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Secondery Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="section_knowledge.secondary_heading" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex flex-col mt-2">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikTextarea name="section_knowledge.description" rootClassName="w-full" as="textarea" />
                  </div>

                  <div className="flex justify-end mt-3">
                    <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={handleAddStep}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <FieldArray name="section_knowledge.steps_section">
                    {(arrayHelpers) => {
                      stepsArrayRef.current = arrayHelpers;
                      return (
                        <div className="mt-2 overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[23.5%] font-normal border px-2 py-2 text-left">Title</th>
                                <th className="w-[23.5%] font-normal border px-2 py-2 text-left">Description</th>
                                <th className="w-[23.5%] font-normal border px-2 py-2 text-left">Steps</th>
                                <th className="w-[23.5%] font-normal border px-2 py-2 text-left">Image</th>
                                <th className="w-[23.5%] font-normal border px-2 py-2 text-left">Alt Tag</th>
                                <th className="w-[6%] font-normal border px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.section_knowledge?.steps_section?.map((item, index) => (
                                <tr key={index}>
                                  <td className="w-[23.5%] border px-2 py-2 align-top">
                                    <div className="min-w-0 w-full overflow-hidden">
                                      <FormikInput name={`section_knowledge.steps_section.${index}.title`} rootClassName="w-full" />
                                    </div>
                                  </td>
                                  <td className="w-[23.5%] border px-2 py-2 align-top">
                                    <div className="min-w-0 w-full overflow-hidden">
                                      <FormikTextarea name={`section_knowledge.steps_section.${index}.description`} rootClassName="w-full" />
                                    </div>
                                  </td>
                                  <td className="w-[23.5%] border px-2 py-2 align-top">
                                    <div className="min-w-0 w-full overflow-hidden">
                                      <FormikInput name={`section_knowledge.steps_section.${index}.steps`} rootClassName="w-full" />
                                    </div>
                                  </td>
                                  <td className="w-[23.5%] border px-2 py-2 align-top">
                                    <div className="min-w-0 w-full overflow-hidden">
                                      <ImageUploader
                                        title="image"
                                        imageUrl={item?.image}
                                        onChange={(res) => setFieldValue(`section_knowledge.steps_section.${index}.image`, res?.data?.file_url)}
                                        imgStyle={{ width: "8rem" }}
                                      />
                                    </div>
                                  </td>
                                  <td className="w-[23.5%] border px-2 py-2 align-top">
                                    <div className="min-w-0 w-full overflow-hidden">
                                      <FormikInput name={`section_knowledge.steps_section.${index}.alt_tag`} rootClassName="w-full" />
                                    </div>
                                  </td>
                                  <td className="w-[6%] border px-2 py-2 text-center align-top">
                                    <div className="flex justify-center cursor-pointer" onClick={handleDeleteStep(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    }}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Pricing Plans</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label label="Primary Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="section_pricing_plans.heading" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex flex-col mt-2">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikTextarea name="section_pricing_plans.description" rootClassName="w-full" as="textarea" />
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="6" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Top Works Tools</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="section_tools.heading" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex flex-col mt-2">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikTextarea name="section_tools.description" rootClassName="w-full" as="textarea" />
                  </div>
                  <div className="flex justify-end mt-3">
                    <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={handleToolAdd}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <FieldArray name="section_tools.tools">
                    {(arrayHelpers) => {
                      toolsArrayRef.current = arrayHelpers;

                      return (
                        <div className="mt-3 overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[47%] border font-normal border-gray-300 px-2 py-2 text-left">Tools</th>
                                <th className="w-[47%] border font-normal border-gray-300 px-2 py-2 text-left">Alt Tag</th>
                                <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.section_tools?.tools?.map((item, index) => (
                                <tr key={index}>
                                  <td className="w-[47%] border border-gray-300 px-4 py-2">
                                    <ImageUploader
                                      imgStyle={{ width: "8rem" }}
                                      title="image"
                                      imageUrl={item?.image_url}
                                      onChange={(res) => setFieldValue(`section_tools.tools.${index}.image_url`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="w-[47%] border border-gray-300 px-2 py-2">
                                    <FormikInput name={`section_tools.tools.${index}.alt_tag`} rootClassName="w-full" />
                                  </td>
                                  <td className="w-[6%] border border-gray-300 px-4 py-2">
                                    <div className="flex justify-center cursor-pointer" onClick={handleToolDelete(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    }}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="7" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Testimonial Heading</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="section_testimonials.heading" rootClassName="w-full" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="8" className="w-[100%] ml-[1rem] mb-5 ">
                <Accordion.Header>Level Up Your Training With Gyaankool</Accordion.Header>
                <Accordion.Body>
                  <Accordion>
                    <Accordion.Item eventKey="19">
                      <Accordion.Header>Levels Details</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                          <div className="flex flex-col">
                            <Label label="Title" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="section_level_up.title" rootClassName="w-full" />
                          </div>

                          <div className="flex flex-col">
                            <Label label="CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="section_level_up.cta.label" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="section_level_up.cta.redirect_link" rootClassName="w-full" />
                          </div>
                        </div>
                        <div className="flex flex-col mt-2">
                          <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                          <FormikTextarea name="section_level_up.description" rootClassName="w-full" as="textarea" />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Accordion className="mt-2">
                    <Accordion.Item eventKey="29" className="mb-4">
                      <Accordion.Header>Level Up Information</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-6">
                          <div className="flex flex-col">
                            <Label label="Header One" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="section_level_up.level_up_information.header_one" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="Header Two" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="section_level_up.level_up_information.header_two" rootClassName="w-full" />
                          </div>

                          <div className="flex flex-col">
                            <Label label="Header Third" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="section_level_up.level_up_information.header_three" rootClassName="w-full" />
                          </div>
                        </div>

                        <div className="flex justify-end mt-3">
                          <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={handleLevelUpAdd}>
                            <Plus className="text-white" />
                          </div>
                        </div>

                        <FieldArray name="section_level_up.level_up_information.level_ups">
                          {(arrayHelpers) => {
                            levelUpsArrayRef.current = arrayHelpers;

                            return (
                              <div className="mt-3 overflow-x-auto">
                                <table className="w-full table-fixed border-collapse border border-gray-300">
                                  <thead className="bg-gray-200">
                                    <tr>
                                      <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">Basis</th>
                                      <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">Before</th>
                                      <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">After</th>
                                      <th className="w-[10%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {values?.section_level_up?.level_up_information?.level_ups?.map((_, index) => (
                                      <tr key={index}>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <FormikInput
                                            name={`section_level_up.level_up_information.level_ups.${index}.basis`}
                                            rootClassName="w-full"
                                          />
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <FormikInput
                                            name={`section_level_up.level_up_information.level_ups.${index}.before`}
                                            rootClassName="w-full"
                                          />
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <FormikInput
                                            name={`section_level_up.level_up_information.level_ups.${index}.after`}
                                            rootClassName="w-full"
                                          />
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <div className="flex justify-center cursor-pointer" onClick={handleLevelUpDelete(index)}>
                                            <Trash />
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            );
                          }}
                        </FieldArray>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                isLoading={updateHomeQuery?.isPending}
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>

      {scaleToDelete !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[9999]">
          <div className="bg-white rounded-lg p-5 w-[300px] text-center">
            <p className="text-lg font-semibold mb-4">Are you sure you want to delete?</p>
            <p className="text-sm text-gray-600 mb-4">Click Save afterwards to update the website.</p>

            <div className="flex justify-center gap-4">
              <button type="button" onClick={handleConfirmScaleDelete} className="bg-red-500 text-white px-4 py-2 rounded">
                Yes
              </button>
              <button type="button" onClick={handleCancelScaleDelete} className="bg-gray-300 px-4 py-2 rounded">
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </Section>
  );
}
